import { api, SKIP_AUTO_CONTENT_TYPE_HEADER } from './api';
import { getServerBaseUrl } from 'utils/urlUtils';

// Define a service using a base URL and expected endpoints for image resources
export const imageResourceApi = api.injectEndpoints({
  reducerPath: 'imageResourceApi',
  tagTypes: ['AiProviders', 'Images'],
  endpoints: (builder) => ({
    getImage: builder.query({
      query: ({ category = '', code }) => ({
        url: `/public/images`,
        method: 'GET',
        params: { category, code }
      })
    }),
    listImages: builder.query({
      query: (category = '') => ({
        url: `/public/images/list`,
        method: 'GET',
        params: { category }
      }),
      providesTags: ['Images']
    }),
    uploadImage: builder.mutation({
      query: ({ file, category = '', imageName }) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('category', category);
        formData.append('imageName', imageName);

        return {
          url: `/api/images`,
          method: 'POST',
          body: formData,
          formData: true,
          headers: {
            [SKIP_AUTO_CONTENT_TYPE_HEADER]: 'true'
          }
        };
      },
      invalidatesTags: ['AiProviders', 'Images']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetImageQuery, useListImagesQuery, useUploadImageMutation } = imageResourceApi;

// Helper function to build an image URL with the proper parameters
export const buildImageUrl = (code, category = '') => {
  const params = new URLSearchParams();
  params.append('code', code);
  if (category) {
    params.append('category', category);
  }
  return `${getServerBaseUrl()}/public/images?${params.toString()}`;
};
